import changeCities from "../modules/Utils/changeCities";
import AjaxClass from "../modules/Forms/Validation/ajaxClass";

$(() => {
    changeCities();
    formValidation();

    function formValidation() {
        $('.form').on('submit', function (event) {
            const form = $(this)[0];
            let isValid = true;
    
            $(form).find('input, select, textarea').each(function () {
                const field = $(this);

                if (field.prop('required') && !field.val()) {
                    field.addClass('is-invalid').removeClass('is-valid');
                    isValid = false;
                } else {
                    field.addClass('is-valid').removeClass('is-invalid');
                }
            });
    
            // validação específica para o checkbox
            const check = $(form).find('[name=check]');

            if (!check.is(':checked') && check.prop('required')) {
                check.addClass('is-invalid').removeClass('is-valid');
                isValid = false;
            } else {
                check.addClass('is-valid').removeClass('is-invalid');
            }
    
            if (!isValid) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                // mostra página de sucesso
                event.preventDefault();
                sendForm(form);
            }
        });
    
        // remover mensagem de erro ao corrigir
        $('input, select, textarea').on('input change', function () {
            if ($(this).val() || $(this).is(':checked')) {
                $(this).addClass('is-valid').removeClass('is-invalid');
            } else {
                $(this).addClass('is-invalid').removeClass('is-valid');
            }
        });
    }

    function showSuccessPageContact() {
        $(".contact").addClass('d-none')
        $(".contact-success").removeClass('d-none');
    }

    function sendForm(form) {
        let type = 'POST';
        let url = $(form).attr('action');
        let dataType = 'json';
        const modalSuccess = document.getElementById('success-message-forms');
        const modalSuccessDescription = document.querySelector('#success-message-forms .description');
        const modalError = document.getElementById('error-message-forms');
        const modalDescription = document.querySelector('#error-message-forms .description');
        let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));

        let images = form.querySelectorAll('input[type=file]');
        if (images.length > 0) {
            images.forEach(e => {
                let image = { name: e.name, value: e.files[0] };
                fields.push(image);
            });
        }
        let formData = new FormData(form);
        if (images.length > 0) {
            fields.forEach(obj => {
                if (!obj.value) obj.value = '';
                formData.append(obj.name, obj.value);
            });
        }
        $(form).attr('disabled', 'disabled');
        class Contact extends AjaxClass {
            successFunction(data, form) {
                if (data.status == true) {
                    $(form).trigger("reset");
                    $(form).removeAttr('disabled');
                    if ($(form).attr('id') == 'contact-form') {
                        showSuccessPageContact();
                    } else {
                        modalSuccess.classList.add("open-modal");
                        modalSuccessDescription.innerHTML = data.txt
                    }
                    if ($(form).attr('id') == 'sale-form') {
                        $("#close").trigger('click')
                    }
                } else {
                    modalDescription.innerHTML = data.txt;
                    modalError.classList.add("open-modal");
                    $(form).removeAttr('disabled');
                }
            };
            errorFunction(xhr, textStatus, errorThrown) {
                modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                if (errorThrown == 'Too Many Requests' || xhr.responseText == 'Too Many Requests') {
                    modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                }
                modalError.classList.add("open-modal");
                $(form).removeAttr('disabled');
            };
        }
        let ajax = new Contact(form, type, url, dataType, formData);
        ajax.send();
    }
})